import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";

const SpeakerAbout = () => {
    return (
        <div className="rn-splite-style px-4 py-10 md:py-16">
            <div className="max-w-4xl mx-auto space-y-8">
                <ScrollAnimation animateIn="fadeInUp" animateOnce>
                    <h2 className="text-3xl font-semibold tracking-tight mb-4">About</h2>
                </ScrollAnimation>

                <ScrollAnimation animateIn="fadeInUp" animateOnce>
                    <p className="text-base leading-relaxed">
                        Jahid Hasan is a serial entrepreneur, life & business strategist, investor, and personal finance mentor
                        who helps individuals and entrepreneurs build wealth, scale businesses, and achieve Life & Financial
                        Freedom. With over a decade of experience, he has guided more than 4,000+ people, from professionals
                        and business owners to those looking to multiply their income.
                    </p>
                </ScrollAnimation>

                <ScrollAnimation animateIn="fadeInUp" animateOnce>
                    {/* <ul className="space-y-3"> */}
                        <p className="mb-1"><strong> Income Growth & Personal Finance:</strong> I help individuals increase their earnings, build multiple income streams, and create long-term financial security.</p>
                        <p className="mb-1"><strong> Business Growth & Consulting:</strong> I work with entrepreneurs & SMEs to optimize business models, improve sales, and achieve high-margin scalability.</p>
                        <p><strong> Investment & Wealth Strategy:</strong> I provide guidance on smart investments, asset management, and financial planning to secure future wealth.</p>
                    {/* </ul> */}
                </ScrollAnimation>

                <ScrollAnimation animateIn="fadeInUp" animateOnce>
                    <div className="space-y-3">
                        <h5 className="font-semibold mt-5">Who Should Work With Me?</h5>
                        <ul className="list-disc list-inside">
                            <li className="mb-1"><strong>Ambitious Professionals:</strong> If you're earning well but feel stuck financially, I’ll help you optimize your income, savings, and investments.</li>
                            <li className="mb-1"><strong>Entrepreneurs & Business Owners:</strong> If you want to scale your business, increase revenue, or build an automated income model, I’ll provide proven growth strategies.</li>
                            <li><strong>Side Hustlers & Investors:</strong> If you're looking to create additional income streams, invest wisely, and build wealth, I’ll show you step-by-step how to do it.</li>
                        </ul>
                    </div>
                </ScrollAnimation>

                <ScrollAnimation animateIn="fadeInUp" animateOnce>
                    <div className="space-y-3">
                        <h5 className="font-semibold">Why Work With Me?</h5>
                        <ul className="list-disc list-inside">
                            <li className="mb-1">Built multiple businesses worth 9-figure valuation, including Sislo Media, Passionate World University, and Asset Link Community.</li>
                            <li className="mb-1">15+ years of counseling experience, having guided over 4,000 individuals.</li>
                            <li className="mb-1">Practical, actionable strategies with no fluff — only proven methods that work.</li>
                            <li className="mb-1">Premium consulting, with clients investing from 11,500 to 3 million+ BDT for one-on-one sessions, workshops, and business coaching.</li>
                        </ul>
                    </div>
                </ScrollAnimation>

                <ScrollAnimation animateIn="fadeInUp" animateOnce>
                    <p className="font-medium">Let’s Work Together: If you’re serious about growing your life, income, business, and financial future, let’s talk. Your next level starts now!</p>
                </ScrollAnimation>
            </div>
        </div>
    );
};

export default SpeakerAbout;
